import { forwardRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TextArea } from "semantic-ui-react";
import {
  createJobFlags,
  jobFlagsByJobId,
  updateJobFlags,
} from "../../../api/jobApi";
import {
  getBulkDropdownData,
  getDropdownData,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import { statusIdsByContexts } from "../../../api/statusApi";
import { AUTH_TYPES, FORMS, MODULES, STATUS_GROUPS } from "../../../const";
import { isNumber } from "../../../helper";
import Grid from "../../Grid";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import LoadingSpinner from "../../LoadingSpinner";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import SelectRenderer from "../../renderer/SelectRenderer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
} from "../../renderer/StyleRenderer";
import { flagFormValidation } from "../../validations/jobMonitor";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const form = FORMS.JOB.FLAG.form;

const JobMonitorFlag = forwardRef(
  (
    { type, jobId, jobCode, requestId, requestCode, close, currentStatus },
    ref,
  ) => {
    const [currentErrors, setCurrentErrors] = useState({});

    const [typeOptions, setTypeOptions] = useState([]);
    const [resolvedOptions, setResolvedOptions] = useState([]);
    const [activeOptions, setActiveOptions] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [flags, setFlags] = useState([]);
    const [currentFlag, setCurrentFlag] = useState({});
    const [flagCount, setFlagCount] = useState(2);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [deletedList, setDeletedList] = useState([]);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const [editMode, setEditMode] = useState(false);
    const [currentValues, setCurrentValues] = useState([]);
    const [disputeTypeOptions, setDisputeTypeOptions] = useState([]);
    const [frEnableList, setFrEnableList] = useState([]);
    const user = useSelector((state) => state.user);

    const [flagData, setFlagData] = useState({
      jfgCode: "",
      jfgRequest: requestId,
      jfgRequestCode: requestCode,
      jfgJob: jobId,
      jfgJobCode: jobCode,
      jfgType: type,
      jfgFlagType: "",
      jfgFlagTypeValue: "",
      jfgResolved: "",
      jfgActive: 1,
      jfgActiveValue: "",
      jfgRemarks: "",
      jfgResolvedRemark: "",
      jfgResolvedBy: "",
      createdBy: user.username,
    });

    useEffect(() => {
      (async () => {
        setIsLoading(true);
        //new
        const { flag_resolve_status: resolvedData, active: activeData } =
          await getBulkDropdownData([
            { key: "flag_resolve_status" },
            { key: "active" },
          ]);

        setResolvedOptions(resolvedData);
        setActiveOptions(activeData);

        //old

        const typeData = await getDropdownData("flag_type", type);
        setTypeOptions(typeData);

        const flagData = await jobFlagsByJobId(jobId, parseInt(type));
        console.log("flag data", flagData);
        const {
          [parseInt(type) === 1
            ? STATUS_GROUPS.FLAG_ENABLED
            : STATUS_GROUPS.REMARK_ENABLED]: flagRemarkEnableList = [],
        } = await statusIdsByContexts([
          parseInt(type) === 1
            ? STATUS_GROUPS.FLAG_ENABLED
            : STATUS_GROUPS.REMARK_ENABLED,
        ]);
        setFrEnableList(flagRemarkEnableList);

        setEditMode(flagData !== null && flagData.length !== 0);
        setCurrentValues(flagData);
        setIsLoading(false);
      })();
    }, [jobId, type]);

    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentFlags = [];
          let id = 2;

          for (let currentValue of currentValues) {
            const jfgFlagTypeValue = await getTextByValueAndKey(
              "flag_type",
              currentValue.jfgFlagType,
            );

            const jfgActiveValue = await getTextByValueAndKey(
              "active",
              currentValue.jfgActive,
            );

            currentFlags.push({
              ...currentValue,
              jobRequest: currentValue.jfgRequestId,
              jfgRequest: currentValue.jfgRequestId,
              jfgJob: currentValue.jfgJobId,
              jfgFlagTypeValue,
              jfgActiveValue,
              jfgResolvedBy: currentValue.jfgResolvedBy,
              createdBy: currentValue.createdBy,
              id,
            });
            id++;
          }
          setFlagCount(id);
          setFlags(currentFlags);
        }
      })();
    }, [editMode, currentValues]);

    console.log(editMode);

    useEffect(() => {
      if (buttonClicked) {
        setFlagData({
          jfgCode: "",
          jfgRequest: requestId,
          jfgRequestCode: requestCode,
          jfgJob: jobId,
          jfgJobCode: jobCode,
          jfgType: type,
          jfgFlagType: "",
          jfgFlagTypeValue: "",
          jfgResolved: "",
          jfgActive: 1,
          jfgActiveValue: "",
          jfgRemarks: "",
          jfgResolvedBy: "",
          createdBy: user.username,
        });
        setCurrentFlag({});
        setCurrentErrors({});
        setButtonClicked(false);
      }
    }, [buttonClicked, jobId, jobCode, requestId, requestCode, type]);

    console.log(flags);

    useEffect(() => {
      if (Object.keys(currentFlag).length > 0) {
        setFlagData({
          ...currentFlag,
          jfgFlagTypeValue: "",
          jfgActiveValue: "",
        });
      }
    }, [currentFlag]);

    useEffect(() => {
      const fetchDisputeTypeOptions = async () => {
        const options = await getDropdownData("flag_type", 4);
        setDisputeTypeOptions(options.map((option) => option.value));
      };
      fetchDisputeTypeOptions();
    }, []);

    const submitHandler = async () => {
      setIsSubmitLoading(true);
      if (!frEnableList.includes(currentStatus)) {
        toast.warn(
          `Cannot update/create ${parseInt(type) === 1 ? "flag" : "remark"} in this stage of the job!`,
          { autoClose: 5000, containerId: "Modal" },
        );
        setIsSubmitLoading(false);
        return;
      }

      //if Flag, not remark
      if (parseInt(type) === 1) {
        const invalidRows = flags.filter(
          (jfg) =>
            Number(jfg.jfgResolved) === 1 && !jfg.jfgResolvedRemark?.trim(),
        );

        if (invalidRows.length > 0) {
          toast.error(
            "Resolved Remark is required for all rows where Resolved status is Resolved.",
            { autoClose: 5000, containerId: "Modal" },
          );

          setFlags((prev) => [...prev]);

          setIsSubmitLoading(false);
          return;
        }
      }

      if (editMode) {
        const updateState = {
          modified: [],
          created: [],
          deleted: deletedList,
        };

        flags.forEach((jfg) => {
          if (jfg.jfgId) {
            if (jfg.modified) {
              updateState.modified.push(jfg);
            }
          } else {
            updateState.created.push(jfg);
          }
        });

        try {
          await updateJobFlags({
            jobId,
            jobFlagRequests: updateState,
            author: user.username,
          });
          toast.success(
            `Job ${parseInt(type) === 1 ? "flag" : "remark"} updated successfully!`,
            { autoClose: 10000, containerId: "Main" },
          );
          close();
        } catch (e) {
          toast.error(
            `Error while updating job ${parseInt(type) === 1 ? "flag" : "remark"}!`,
            { autoClose: 5000, containerId: "Modal" },
          );
        }
      } else {
        try {
          if (flags && flags.length === 0) {
            toast.warn(
              `No ${parseInt(type) === 1 ? "flag" : "remark"} to save!`,
              {
                autoClose: 5000,
                containerId: "Modal",
              },
            );
            close(false);
            return;
          }

          await createJobFlags({
            jobFlagRequests: flags,
            author: user.username,
          });
          toast.success(
            `Job ${parseInt(type) === 1 ? "flag" : "remark"} created successfully!`,
            { autoClose: 10000, containerId: "Main" },
          );
          close();
        } catch (e) {
          toast.error(
            `Error while creating job ${parseInt(type) === 1 ? "flag" : "remark"}!`,
            { autoClose: 5000, containerId: "Modal" },
          );
        }
      }
      setIsSubmitLoading(false);
    };

    const onAddClick = async () => {
      setIsAddLoading(true);
      const flagErrors = flagFormValidation(flagData);

      // ✅ Add validation for Resolved Remark when resolved is Resolved
      if (
        parseInt(type) === 1 &&
        flagData.jfgResolved === 1 &&
        !flagData.jfgResolvedRemark?.trim()
      ) {
        flagErrors.jfgResolvedRemark =
          "Resolved remark is required when resolved status is Resolved.";
      }

      if (Object.keys(flagErrors).length === 0) {
        const jfgFlagTypeValue = await getTextByValueAndKey(
          "flag_type",
          flagData.jfgFlagType,
        );

        const jfgActiveValue = await getTextByValueAndKey(
          "active",
          flagData.jfgActive,
        );

        const resBy = flagData.jfgResolved === 1 ? user.username : "";

        if (!flagData.jfgId) {
          if (!flagData.id) {
            setFlags((prevFlags) => [
              ...prevFlags,
              {
                ...flagData,
                jfgFlagTypeValue,
                jfgActiveValue,
                jfgResolvedBy: resBy,
                id: flagCount,
              },
            ]);
            setFlagCount((prevCount) => prevCount + 1);
          } else {
            setFlags((prevState) =>
              prevState.filter((flag) => flag.id !== flagData.id),
            );
            setFlags((prevFlags) => [
              ...prevFlags,
              {
                ...flagData,
                jfgFlagTypeValue,
                jfgActiveValue,
                jfgResolvedBy: resBy,
              },
            ]);
          }
        } else {
          setFlags((prevState) =>
            prevState.filter((flag) => flag.jfgId !== flagData.jfgId),
          );
          setFlags((prevFlags) => [
            ...prevFlags,
            {
              ...flagData,
              jfgFlagTypeValue,
              jfgActiveValue,
              jfgResolvedBy: resBy,
              modified: true,
            },
          ]);
        }
        setButtonClicked(true);
      }
      setCurrentErrors(flagErrors);
      setIsAddLoading(false);
    };

    const cellEditorParams = (params) => {
      console.log("params in cell editor", params);

      switch (params.colDef.field) {
        case "jfgResolvedRemark": {
          const resBy =
            Number(params.data.jfgResolved) === 1 && params.value?.trim()
              ? user.username
              : "";
          setFlags((prev) =>
            prev.map((item) => {
              if (item.id !== params.data.id) return item;

              return {
                ...item,
                jfgResolvedRemark: params.value,
                jfgResolvedBy: resBy,
                modified: item.jfgId ? true : false,
              };
            }),
          );
          break;
        }

        default:
      }
    };
    const getConfig = () => {
      let configData = [];
      //If flag
      if (parseInt(type) === 1) {
        configData = [
          {
            headerName: "Resolved",
            field: "jfgResolved",
            cellRenderer: SelectRenderer,
            tooltipValueGetter: (params) => {
              return params.data.jfgResolved === 1 &&
                !params.data.jfgResolvedRemark?.trim()
                ? "Resolved Remark is required"
                : "select resolved status";
            },
            cellRendererParams: (params) => ({
              onChangeHandler: (data) => {
                console.log("params", params);
                console.log("params data", data);
                const resBy =
                  Number(data) === 1 && params.data.jfgResolvedRemark?.trim()
                    ? user.username
                    : "";
                setFlags((prev) =>
                  prev.map((item) => {
                    if (item.id !== params.data.id) return item;

                    return data === 1
                      ? {
                          ...item,
                          jfgResolved: Number(data),
                          jfgResolvedBy: resBy,
                          modified: item.jfgId ? true : false,
                        }
                      : {
                          ...item,
                          jfgResolved: Number(data),
                          jfgResolvedRemark: "",
                          jfgResolvedBy: resBy,
                          modified: item.jfgId ? true : false,
                        };
                  }),
                );
              },
              options: resolvedOptions,
              placeholder: "Resolved Status",
              value: params.data.jfgResolved,
            }),
          },
          {
            headerName: "Resolved Remark",
            field: "jfgResolvedRemark",
            cellEditor: "agTextCellEditor",
            cellEditorParams: {
              maxLength: 200,
            },
            tooltipValueGetter: (params) => {
              return params.data.jfgResolved === 1 &&
                !params.data.jfgResolvedRemark?.trim()
                ? "Resolved Remark is required"
                : "If editable, Press Enter or click outside to set the value";
            },
            editable: (params) => {
              return params.data.jfgResolved === 1;
            },
            cellRenderer: ResizableScrollingTextRenderer,
            minWidth: 300,
            cellStyle: (params) => {
              const required =
                params.data.jfgResolved === 1 &&
                !params.data.jfgResolvedRemark?.trim();
              console.log("required", required);
              return required
                ? {
                    outline: "2px solid red",
                    border: "2px solid red",
                    transition: "background-color 200ms ease",
                    backgroundColor: "#fff1f1",
                  }
                : {};
            },
          },
        ];
      } else {
        configData = [
          {
            headerName: "Resolved",
            field: "jfgResolved",
            cellRenderer: SelectRenderer,
            tooltipValueGetter: (params) => {
              return "select resolved status";
            },
            cellRendererParams: (params) => ({
              onChangeHandler: (data) => {
                console.log("params", params);
                console.log("params data", data);
                const resBy = Number(data) === 1 ? user.username : "";
                setFlags((prev) =>
                  prev.map((item) => {
                    if (item.id !== params.data.id) return item;

                    return data === 1
                      ? {
                          ...item,
                          jfgResolved: Number(data),
                          jfgResolvedBy: resBy,
                          modified: item.jfgId ? true : false,
                        }
                      : {
                          ...item,
                          jfgResolved: Number(data),
                          jfgResolvedBy: resBy,
                          modified: item.jfgId ? true : false,
                        };
                  }),
                );
              },
              options: resolvedOptions,
              placeholder: "Resolved Status",
              value: params.data.jfgResolved,
            }),
          },
        ];
      }

      let common = [
        {
          headerName: "Type",
          field: "jfgFlagTypeValue",
          cellRenderer: ResizableScrollingTextRenderer,
        },
        {
          headerName: "Flagged By",
          field: "createdBy",
          cellRenderer: ResizableScrollingTextRenderer,
        },
        {
          headerName: "Resolved By",
          field: "jfgResolvedBy",
          cellRenderer: ResizableScrollingTextRenderer,
        },
        {
          headerName: "Remark",
          field: "jfgRemarks",
          cellRender: ResizableScrollingTextRenderer,
        },
        {
          headerName: "Received Time",
          field: "jfgTime",
          cellRenderer: (params) => {
            if (!params.value) return "";
            try {
              const date = new Date(params.value);
              return date.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              });
            } catch {
              return params.value;
            }
          },
        },
        {
          headerName: "Resolved Time",
          field: "lastModifiedDate",
          cellRenderer: (params) => {
            const data = params.data || {};
            if (
              !data.jfgId ||
              data.jfgResolved !== 1 ||
              !data.lastModifiedDate
            ) {
              return "";
            }

            try {
              const date = new Date(data.lastModifiedDate);
              return date.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              });
            } catch {
              return "";
            }
          },
        },
        {
          headerName: "Active",
          field: "jfgActiveValue",
          cellRenderer: ActiveCellStyle,
        },
        {
          field: "Edit",
          filter: true,
          cellRenderer: ButtonRenderer,
          cellRendererParams: (params) => {
            const isDisputable = disputeTypeOptions.includes(
              params.data.jfgFlagType,
            );

            return {
              clickHandler: () => {
                if (isDisputable) {
                  toast.info(
                    "This Flag created through job confirmation process",
                    { autoClose: 5000, containerId: "Modal" },
                  );
                } else {
                  setCurrentFlag(params.data);
                }
              },
              label: "Edit",
              className: "ui blue button",
              pinned: "right",
            };
          },
        },
        {
          field: "Delete",
          filter: true,
          cellRenderer: DeleteButtonRenderer,
          cellRendererParams: (params) => {
            const isDisputable = disputeTypeOptions.includes(
              params.data.jfgFlagType,
            );
            return {
              clickHandler: () => {
                if (isDisputable) {
                  toast.info(
                    "This Flag created through job confirmation process",
                    { autoClose: 5000, containerId: "Modal" },
                  );
                } else {
                  if (params.data.jfgId) {
                    setDeletedList((prevState) => [
                      ...prevState,
                      params.data.jfgId,
                    ]);
                  }
                  setFlags((prevFlags) =>
                    prevFlags.filter((flag) => flag.id !== params.data.id),
                  );
                }
              },
              label: "Delete",
              className: "ui red button",
              authenticated: true,
              form: `${form}_${type}`,
              module: MODULES.Transaction,
              editMode:
                params.data.jfgId !== null && isNumber(params.data.jfgId),
              consider: AUTH_TYPES.DELETE,
              disabled: parseInt(type) === 1,
              pinned: "right",
            };
          },
        },
      ];

      return [...configData, ...common];
    };

    console.log("Flags", flags);
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">
                {parseInt(type) === 1 ? "Flags" : "Remarks"}
              </h4>

              <Input
                label={parseInt(type) === "1" ? "Flag Code" : "Remark Code"}
                error={currentErrors.jfgCode}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { jfgCode: _, ...rest } = prevState;
                    return rest;
                  })
                }
                form={`${form}_${type}`}
                name="flagCode"
                value={flagData.jfgCode}
                readOnly={true}
              />

              <div className="two fields">
                <Input
                  label="Job Code"
                  error={currentErrors.jfgJobId}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { jfgJobId: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="flagJobId"
                  value={jobCode}
                  readOnly={true}
                />
                <Dropdown
                  required={true}
                  label={type === "1" ? "Flag Type" : "Remark Type"}
                  error={currentErrors.jfgFlagType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { jfgFlagType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  search={true}
                  icon="search"
                  placeholder={type === "1" ? "Flag Type" : "Remark Type"}
                  options={typeOptions}
                  value={flagData.jfgFlagType}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setFlagData((prevState) => ({
                      ...prevState,
                      jfgFlagType: data.value,
                    }));
                  }}
                  onFocus={(e) => {
                    e.preventDefault();
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Resolved"
                  error={currentErrors.jfgResolved}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { jfgResolved: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Resolved"
                  options={resolvedOptions}
                  value={flagData.jfgResolved}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setFlagData((prevState) => ({
                      ...prevState,
                      jfgResolved: data.value,
                    }));
                  }}
                />
                {/* <Dropdown
                  disabled={parseInt(type) === 1}
                  required={true}
                  label="Active"
                  error={currentErrors.jfgActive}
                  editMode={editMode}
                  module={MODULES.Transaction}
                  form={`${form}_${type}`}
                  field="jfg_active"
                  authenticated={true}
                  needDeletePermission={true}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { jfgActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={flagData.jfgActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setFlagData((prevState) => ({
                      ...prevState,
                      jfgActive: data.value,
                    }));
                  }}
                  onFocus={(e) => {
                    console.log("FOCUSED", e);
                  }}
                /> */}
              </div>
              {parseInt(type) === 1 && flagData.jfgResolved === 1 && (
                <Input
                  required
                  label="Resolved Remark"
                  placeholder="Enter remark for resolution"
                  value={flagData.jfgResolvedRemark}
                  error={currentErrors.jfgResolvedRemark}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { jfgResolvedRemark: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  onChange={(e) =>
                    setFlagData((prevState) => ({
                      ...prevState,
                      jfgResolvedRemark: e.target.value,
                    }))
                  }
                />
              )}

              <div
                className={`field ${currentErrors.jfgRemarks ? "error" : ""}`}
              >
                <label>Remarks</label>
                <TextArea
                  placeholder="Remarks"
                  value={flagData.jfgRemarks}
                  onChange={(e, data) =>
                    setFlagData((prevState) => ({
                      ...prevState,
                      jfgRemarks: data.value,
                    }))
                  }
                />
                <small style={{ color: "#9f3a38" }}>{`${
                  currentErrors.jfgRemarks ? currentErrors.jfgRemarks : ""
                }`}</small>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                  marginTop: "10px",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  create={Object.keys(currentFlag).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                heading={type === "1" ? "Flags" : "Remarks"}
                // stopEditingWhenCellsLoseFocus={true}
                onCellEditingStopped={cellEditorParams}
                fullRowEdit={false}
                config={getConfig()}
                content={flags}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                  marginTop: "10px",
                }}
              >
                <Button
                  template="create"
                  onClick={submitHandler}
                  isLoading={isSubmitLoading}
                />
              </div>
            </div>
          </form>
        )}
      </>
    );
  },
);

export default JobMonitorFlag;
